function cov_1fzre5u6ld() {
  var path = "/app/src/components/shadow-view/constants.ts";
  var hash = "d067c06e8ad63bd5eef52c680562d025ed97feab";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/shadow-view/constants.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 31,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d067c06e8ad63bd5eef52c680562d025ed97feab"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1fzre5u6ld = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1fzre5u6ld();
export var SHADOW_VIEW_INITIAL_PROPERTIES = (cov_1fzre5u6ld().s[0]++, ['border-collapse', 'border-spacing', 'caption-side', 'color', 'cursor', 'direction', 'empty-cells', 'letter-spacing', 'line-height', 'list-style-image', 'list-style-position', 'list-style-type', 'list-style', 'orphans', 'quotes', 'tab-size', 'text-align', 'text-align-last', 'text-decoration-color', 'text-indent', 'text-justify', 'text-shadow', 'text-transform', 'visibility', 'white-space', 'widows', 'word-break', 'word-spacing', 'word-wrap']);